import styled from 'styled-components';

export const FilterItemDiv = styled.div`
    display: grid;
    grid-template-columns: ${({ gridTemplateColumns }) =>
        gridTemplateColumns ? gridTemplateColumns : 'auto 30% 16px'};
    width: 100%;
    @media only screen and (max-width: 350px) {
        grid-template-columns: auto 35% 16px;
    }
`;
export const FilterAccountNameDiv = styled.div`
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    width: 100%;
    grid-column: 1/2;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: AvenirNextWorld Regular;
    letter-spacing: -0.12px;
    color: #000000;
    font-size: 15px;
`;
export const FilterAccountNumberDiv = styled.div`
    min-width: 30%;
    font-style: italic;
    letter-spacing: -0.12px;
    color: #000000;
    grid-column: ${({ gridColumns }) => (gridColumns ? gridColumns : '2/3')};
    font-size: 15px;
`;

export const FilterFavouriteIconDiv = styled.div`
    grid-column: 3/-1;
    align-items: center;
    display: ${({ display }) => (display ? display : 'flex')};
    justify-content: center;
`;
